import { orderBy, query } from "firebase/firestore";
import getNewsCollRef from "../../../firebase/news/getNewsCollRef";

const getNewsQuery = () => {
  return query(getNewsCollRef(), orderBy('createdAt','desc'));
}

export default getNewsQuery;